module.exports = __webpack_public_path__ + "img/61_1.4cdb1d3d.png";